/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bidbattle__Status__Finished8Inputs */

const en_bidbattle__status__finished8 = /** @type {(inputs: Bidbattle__Status__Finished8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete`)
};

/**
* | output |
* | --- |
* | "Complete" |
*
* @param {Bidbattle__Status__Finished8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const bidbattle__status__finished8 = /** @type {((inputs?: Bidbattle__Status__Finished8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bidbattle__Status__Finished8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bidbattle__status__finished8(inputs)
});
export { bidbattle__status__finished8 as "bidbattle__status__FINISHED" }